export const messages = {
  en: {
    listOwnerCar: {
      searchCondition: 'Search Condition',
      inputCarNum: 'Please enter the license plate number',
      inputParkingSpaceNum: 'Please fill in the parking space number',
      selectParkingSpaceStatus: 'Required, please select the parking space status',
      inputOwnerName: 'Please fill in the owner name',
      inputContact: 'Please enter contact information',
      inputTel: 'Optional, please fill in contact phone',
      telFormat: 'Incorrect contact phone format',
      inputMemberCarNum: 'Please enter member license plate number',
      query: 'Query',
      reset: 'Reset',
      carInfo: 'Car Information',
      importCar: 'Import Cars',
      export: 'Export',
      add: 'Add',
      carNum: 'License Plate Number',
      memberCar: 'Member Car',
      roomNum: 'Room Number',
      carPlateType: 'License Plate Type',
      carType: 'Car Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      parkingArea: 'Parking Area',
      selectParkingArea: 'Please select parking area',
      validity: 'Validity',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      temporaryCar: 'Temporary Car',
      parkingSpaceReleased: 'Parking space released',
      parkingAreaSuffix: 'Parking Lot',
      noFixedSpace: 'No Fixed Space',
      normal: 'Normal',
      expired: 'Expired',
      noParkingSpace: 'No Parking Space',
      release: 'Release',
      renew: 'Renew',
      buyMonthlyCard: 'Buy Monthly Card',
      modify: 'Modify',
      delete: 'Delete',
      confirmDelete: 'Are you sure to delete?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      importCarTitle: 'Car Import',
      selectFile: 'Select File',
      downloadTemplate: 'Download Template',
      importTemplate: 'Import Template',
      prepareData: 'Prepare data and upload',
      import: 'Import',
      editCar: 'Edit Car',
      carBrand: 'Car Brand',
      contact: 'Contact Person',
      tel: 'Contact Phone',
      inputCarBrand: 'Optional, please fill in the car brand, e.g. BMW X6',
      inputCarNumRequired: 'Required, please fill in the license plate number',
      selectType: 'Required, please select type',
      inputCarColor: 'Optional, please fill in the car color, e.g. white',
      licensePlateType: 'License Plate Type',
      selectLicensePlateType: 'Required, please select license plate type',
      monthlyRentCar: 'Monthly Rent Car',
      soldCar: 'Sold Car',
      internalCar: 'Internal Car',
      freeCar: 'Free Car',
      startRentTime: 'Start Rent Time',
      endRentTime: 'End Rent Time',
      inputStartRentTime: 'Required, please fill in the start rent time',
      inputEndRentTime: 'Required, please fill in the end rent time',
      inputRemark: 'Please fill in remarks',
      save: 'Save',
      deleteCarConfirm: 'Confirm whether to delete',
      fileRequired: 'Required, please select data file',
      invalidExcel: 'Invalid Excel format',
      fileSizeExceed: 'Excel file size cannot exceed 2M',
      importSuccess: 'Import successful',
      importError: 'Import failed',
      updateSuccess: 'Update successful',
      updateError: 'Update failed',
      deleteSuccess: 'Delete successful',
      deleteError: 'Delete failed',
      releaseSuccess: 'Release successful',
      releaseError: 'Release failed',
      exportSuccess: 'Export successful',
      exportError: 'Export failed',
      fetchError: 'Failed to get data',
      allCars: 'All Cars',
      expiredCars: 'Expired Cars',
      downloadFirst: 'Please download first ',
      selectTypeRequired: 'Please select car type',
      selectLicensePlateTypeRequired: 'Please select license plate type',
      rentTimeRequired: 'Please fill in rent time',
      endTimeAfterStart: 'End time must be after start time',
      iotSyncDetail: 'IoT sync details',
      confirmRelease: 'Are you sure to release the car?',
      parkingLot: 'Parking Lot',
       changeOwner: 'Change Owner',
      ownerName: 'Owner Name',
      phoneNumber: 'Phone Number',
      select: 'Select',
      changeOwnerQueryFailed: 'Failed to query owner list, please try again later',
      changeOwnerSelectTip: 'Please select an owner first',
      changeOwnerTodoTip: 'The change owner operation will be completed after backend API is ready',
      changeOwnerFailed: 'Failed to change owner, please try again later',
    }
  },
  zh: {
    listOwnerCar: {
      searchCondition: '查询条件',
      inputCarNum: '请输入车牌号',
      inputParkingSpaceNum: '请填写车位编号',
      selectParkingSpaceStatus: '必填，请选择车位状态',
      inputOwnerName: '请填写业主名称',
      inputContact: '请输入联系方式',
      inputTel: '选填，请填写联系电话',
      telFormat: '联系电话格式不正确',
      inputMemberCarNum: '请输入成员车牌号',
      query: '查询',
      reset: '重置',
      carInfo: '车辆信息',
      importCar: '车辆导入',
      export: '导出',
      add: '添加',
      carNum: '车牌号',
      memberCar: '成员车辆',
      roomNum: '房屋号',
      carPlateType: '车牌类型',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      parkingArea: '停车场',
      selectParkingArea: '请选择停车场',
      validity: '有效期',
      status: '状态',
      remark: '备注',
      operation: '操作',
      temporaryCar: '临时车',
      parkingSpaceReleased: '车位已释放',
      parkingAreaSuffix: '停车场',
      noFixedSpace: '无固定车位',
      normal: '正常',
      expired: '到期',
      noParkingSpace: '无车位',
      release: '释放',
      renew: '续租',
      buyMonthlyCard: '买月卡',
      modify: '修改',
      delete: '删除',
      confirmDelete: '确认删除？',
      cancel: '取消',
      confirm: '确认',
      importCarTitle: '车辆导入',
      selectFile: '选择文件',
      downloadTemplate: '下载模板',
      importTemplate: '导入模板',
      prepareData: '准备数据后，上传导入',
      import: '导入',
      editCar: '修改车辆',
      carBrand: '车品牌',
      contact: '联系人',
      tel: '联系电话',
      inputCarBrand: '可选，请填写车品牌，如宝马X6',
      inputCarNumRequired: '必填，请填写车牌号',
      selectType: '必填，请选择类型',
      inputCarColor: '可选，请填写车颜色，如白色',
      licensePlateType: '车牌类型',
      selectLicensePlateType: '必填，请选择车牌类型',
      monthlyRentCar: '月租车',
      soldCar: '出售车辆',
      internalCar: '内部车',
      freeCar: '免费车',
      startRentTime: '起租时间',
      endRentTime: '结租时间',
      inputStartRentTime: '必填，请填写起租时间',
      inputEndRentTime: '必填，请填写结租时间',
      inputRemark: '请填写备注信息',
      save: '保存',
      deleteCarConfirm: '确认是否删除',
      fileRequired: '必填，请选择数据文件',
      invalidExcel: '不是有效的Excel格式',
      fileSizeExceed: 'Excel文件大小不能超过2M',
      importSuccess: '导入成功',
      importError: '导入失败',
      updateSuccess: '修改成功',
      updateError: '修改失败',
      deleteSuccess: '删除成功',
      deleteError: '删除失败',
      releaseSuccess: '释放成功',
      releaseError: '释放失败',
      exportSuccess: '导出成功',
      exportError: '导出失败',
      fetchError: '获取数据失败',
      allCars: '全部车辆',
      expiredCars: '到期车辆',
      downloadFirst: '请先下载 ',
      selectTypeRequired: '请选择车辆类型',
      selectLicensePlateTypeRequired: '请选择车牌类型',
      rentTimeRequired: '请填写起租时间和结租时间',
      endTimeAfterStart: '结租时间必须大于起租时间',
      iotSyncDetail: '同步物联网详情',
      confirmRelease: '确认释放车辆？',
parkingLot: '车场',
 changeOwner: '修改业主',
      ownerName: '业主名称',
      phoneNumber: '手机号',
      select: '选择',
      changeOwnerQueryFailed: '查询业主列表失败，请稍后重试',
      changeOwnerSelectTip: '请先选择业主',
      changeOwnerTodoTip: '后端接口开发完成后，将在此完成修改业主操作',
      changeOwnerFailed: '修改业主失败，请稍后重试',
    }
  },
  'zh-TW': {
    listOwnerCar: {
      searchCondition: '查詢條件',
      inputCarNum: '請輸入車牌號',
      inputParkingSpaceNum: '請填寫車位編號',
      selectParkingSpaceStatus: '必填，請選擇車位狀態',
      inputOwnerName: '請填寫業主名稱',
      inputContact: '請輸入聯繫方式',
      inputTel: '選填，請填寫聯絡電話',
      telFormat: '聯絡電話格式不正確',
      inputMemberCarNum: '請輸入成員車牌號',
      query: '查詢',
      reset: '重設',
      carInfo: '車輛信息',
      importCar: '車輛導入',
      export: '導出',
      add: '添加',
      carNum: '車牌號',
      memberCar: '成員車輛',
      roomNum: '房屋號',
      carPlateType: '車牌類型',
      carType: '車輛類型',
      color: '顏色',
      owner: '業主',
      parkingSpace: '車位',
      parkingArea: '停車場',
      selectParkingArea: '請選擇停車場',
      validity: '有效期',
      status: '狀態',
      remark: '備註',
      operation: '操作',
      temporaryCar: '臨時車',
      parkingSpaceReleased: '車位已釋放',
      parkingAreaSuffix: '停車場',
      noFixedSpace: '無固定車位',
      normal: '正常',
      expired: '到期',
      noParkingSpace: '無車位',
      release: '釋放',
      renew: '續租',
      buyMonthlyCard: '買月卡',
      modify: '修改',
      delete: '刪除',
      confirmDelete: '確認刪除？',
      cancel: '取消',
      confirm: '確認',
      importCarTitle: '車輛導入',
      selectFile: '選擇文件',
      downloadTemplate: '下載模板',
      importTemplate: '導入模板',
      prepareData: '準備數據後，上傳導入',
      import: '導入',
      editCar: '修改車輛',
      carBrand: '車品牌',
      contact: '聯絡人',
      tel: '聯絡電話',
      inputCarBrand: '可選，請填寫車品牌，如寶馬X6',
      inputCarNumRequired: '必填，請填寫車牌號',
      selectType: '必填，請選擇類型',
      inputCarColor: '可選，請填寫車顏色，如白色',
      licensePlateType: '車牌類型',
      selectLicensePlateType: '必填，請選擇車牌類型',
      monthlyRentCar: '月租車',
      soldCar: '出售車輛',
      internalCar: '內部車',
      freeCar: '免費車',
      startRentTime: '起租時間',
      endRentTime: '結租時間',
      inputStartRentTime: '必填，請填寫起租時間',
      inputEndRentTime: '必填，請填寫結租時間',
      inputRemark: '請填寫備註信息',
      save: '保存',
      deleteCarConfirm: '確認是否刪除',
      fileRequired: '必填，請選擇數據文件',
      invalidExcel: '不是有效的Excel格式',
      fileSizeExceed: 'Excel文件大小不能超過2M',
      importSuccess: '導入成功',
      importError: '導入失敗',
      updateSuccess: '修改成功',
      updateError: '修改失敗',
      deleteSuccess: '刪除成功',
      deleteError: '刪除失敗',
      releaseSuccess: '釋放成功',
      releaseError: '釋放失敗',
      exportSuccess: '導出成功',
      exportError: '導出失敗',
      fetchError: '獲取數據失敗',
      allCars: '全部車輛',
      expiredCars: '到期車輛',
      downloadFirst: '請先下載 ',
      selectTypeRequired: '請選擇車輛類型',
      selectLicensePlateTypeRequired: '請選擇車牌類型',
      rentTimeRequired: '請填寫起租時間和結租時間',
      endTimeAfterStart: '結租時間必須大於起租時間',
      iotSyncDetail: '同步物聯網詳情',
      confirmRelease: '確認釋放車輛？',
      parkingLot: '車場',
       changeOwner: '修改业主',
      ownerName: '业主名称',
      phoneNumber: '手机号',
      select: '选择',
      changeOwnerQueryFailed: '查询业主列表失败，请稍后重试',
      changeOwnerSelectTip: '请先选择业主',
      changeOwnerTodoTip: '后端接口开发完成后，将在此完成修改业主操作',
      changeOwnerFailed: '修改业主失败，请稍后重试',
    }
  }
}